import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import LazyComponent from '@/components/LazyComponent';
const Home = lazy(() => import('@/pages/home'));
const Knowledge = lazy(() => import('@/pages/knowledge'));
const KnowledgeArticle = lazy(() => import('@/pages/knowledge-article'));
const NewsArticle = lazy(() => import('@/pages/news-article'));
const Apply = lazy(() => import('@/pages/apply'));
const ApplyArticle = lazy(() => import('@/pages/apply-article'));
const NoFound = lazy(() => import('@/components/NoFound'));
const Yingyongjishulianhekaifa = lazy(() => import('@/pages/yingyongjishulianhekaifa'));
const Kaifangshiyanshi = lazy(() => import('@/pages/kaifangshiyanshi'));
const Xuqiudingzhi = lazy(() => import('@/pages/xuqiudingzhi'));
const AboutJz = lazy(() => import('@/pages/about-jz'));
const Message = lazy(() => import('@/pages/message'));
const Custom = lazy(() => import('@/pages/custom'));
const router = [
  {
    path: '/',
    element: <LazyComponent lazyChildren={<Home />} />,
  },
  {
    path: '/knowledge-list/:id',
    element: <LazyComponent lazyChildren={<Knowledge />} />,
  },
  {
    path: '/knowledge/:id',
    element: <LazyComponent lazyChildren={<KnowledgeArticle />} />,
  },
  {
    path: '/news/:id',
    element: <LazyComponent lazyChildren={<NewsArticle />} />,
  },
  {
    path: '/app-list/:id',
    element: <LazyComponent lazyChildren={<Apply />} />,
  },
  {
    path: '/app/:id',
    element: <LazyComponent lazyChildren={<ApplyArticle />} />,
  },
  {
    path: '/yingyongjishulianhekaifa',
    element: <LazyComponent lazyChildren={<Yingyongjishulianhekaifa />} />,
  },
  {
    path: '/kaifangshiyanshi',
    element: <LazyComponent lazyChildren={<Kaifangshiyanshi />} />,
  },
  {
    path: '/xuqiudingzhi',
    element: <LazyComponent lazyChildren={<Xuqiudingzhi />} />,
  },
  {
    path: '/about-jz',
    element: <LazyComponent lazyChildren={<AboutJz />} />,
  },
  {
    path: '/message/:id',
    element: <LazyComponent lazyChildren={<Message />} />,
  },
  {
    path: '/custom',
    element: <LazyComponent lazyChildren={<Custom />} />,
  },
  {
    path: '*',
    element: <LazyComponent lazyChildren={<NoFound />} />,
  },
];

export default createBrowserRouter(router);
